import { Button } from "@risalabs_frontend_org/oasis-ui-kit";
import { useDispatch } from "react-redux";
import { ModalId } from "../../../../../enums/modalId";
import { setOpenedModalId } from "../../../../../redux/slice/modalSlice";
import { AppDispatch } from "../../../../../redux/store/store";
import InfoIconWithBorderedBackground from "../../../../../svg/infoIconWithBorderedBackground";

const NoCptCodesFound = () => {
  const dispatch = useDispatch<AppDispatch>();
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-4">
      <div className="icon-with-bg">
        <InfoIconWithBorderedBackground />
      </div>
      <div className="text-for-not-found text-sm text-primaryGray-3">
        We were not able to fetch any CPT Codes.
      </div>
      <div className="add-cpt-button">
        <Button
          disabled={false}
          children={"Add CPT Code"}
          onClick={() => {
            dispatch(setOpenedModalId({ id: ModalId.ADD_NEW_CPT_CODE_MODAL }));
          }}
          buttonType={"primary"}
          size={"medium"}
        />
      </div>
    </div>
  );
};

export default NoCptCodesFound;
